
import { defineComponent } from "vue";
import Logo from "@/components/LogoHimalia.vue";

export default defineComponent({
  components: { Logo },
  setup() {
    return {
      year: new Date().getFullYear(),
      navLinks: [
        { href: "#sluzby", label: "Služby" },
        { href: "#products", label: "Produkty" },
        { href: "#tim", label: "Tím" },
        { href: "#kontakt", label: "Kontakt" },
      ],
    };
  },
});
